import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { formatCurrency } from '../../../utils/reportHelpers';
import type { OverviewTrendRow } from './types';

export const KioskTrendChart = ({ trend }: { trend: OverviewTrendRow[] }) => {
  const translate = useTranslate();
  return (
    <Box sx={{ mb: 3, minWidth: 0 }}>
      <Typography sx={{ fontWeight: 600, mb: 1 }}>{translate('reports.kiosk.trend.title')}</Typography>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={trend}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis tickFormatter={(value) => formatCurrency(Number(value))} />
          <Tooltip formatter={(value) => formatCurrency(Number(value))} />
          <Legend />
          <Bar dataKey="kiosk_kept" name={translate('reports.kiosk.trend.kioskKept')} fill="#009A75" />
          <Bar dataKey="app_revenue" name={translate('reports.kiosk.trend.appRevenue')} fill="#2196F3" />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};
